import React, { Fragment } from 'react';
import T from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AUTOPAY_SPLASH_DICTIONARY } from '@dmi/shared/redux/Payments/Autopay/constants';
import { FLEX_DRAFT_SPLASH_DICTIONARY } from '@dmi/shared/redux/Payments/FlexDraft/constants';
import { OTP_SPLASH_DICTIONARY } from '@dmi/shared/redux/Payments/OneTimePayment/constants';
import { MAKE_PAYMENT_NO_FEE } from '@dmi/shared/utils/constants';

import iconDictionary from '../../../utils/iconDictionary';
import { SecondaryHeader } from '../../ScreenHeaders';
import { ConditionalRender, StyledScrollView, TertiaryDivider } from '../../base_ui';
import {
  BottomHeader,
  Card,
  Container,
  IllustrationWrapper,
  ListItem,
  ListView,
  StyledButton,
  StyledNoFeeCopy,
  StyledText,
  TopHeader,
} from './styledComponents';

const SplashIllustration = iconDictionary('marketing');

const MakePaymentSplash = ({
  isEligibleForAutopay,
  isEligibleForFlexDraft,
  isEligibleForOtp,
  navigation,
}) => {
  const {
    buttonLabel: flexDraftButtonLabel,
    headerText: flexDraftHeaderText,
    listText: flexDraftListText,
  } = FLEX_DRAFT_SPLASH_DICTIONARY;
  const {
    buttonLabel: autopayButtonLabel,
    headerText: autopayHeaderText,
    listText: autopayListText,
  } = AUTOPAY_SPLASH_DICTIONARY;
  const {
    buttonLabel: otpButtonLabel,
    headerText: otpHeaderText,
  } = OTP_SPLASH_DICTIONARY;

  const handleNavigation = (path) => navigation.replace(path);

  return (
    <StyledScrollView>
      <SecondaryHeader
        handleBack={() => navigation.navigateDeprecated('Payments')}
        title="Make a Payment"
      />
      <Container>
        <StyledNoFeeCopy>{MAKE_PAYMENT_NO_FEE}</StyledNoFeeCopy>
        <Card>
          <IllustrationWrapper>{SplashIllustration}</IllustrationWrapper>
          <ConditionalRender
            Component={(
              <Fragment>
                <TopHeader>{autopayHeaderText}</TopHeader>
                <ListView>
                  {autopayListText.map((text) => (
                    <ListItem key={text}>
                      <StyledText>{'\u2022  '}</StyledText>
                      <StyledText>
                        <FormattedMessage id={text} />
                      </StyledText>
                    </ListItem>
                  ))}
                </ListView>
                <StyledButton
                  label={autopayButtonLabel}
                  onPress={() => handleNavigation('AutopayPreConfirmation')}
                />
              </Fragment>
            )}
            shouldRender={isEligibleForAutopay}
          />
        </Card>
        <ConditionalRender
          Component={(
            <Fragment>
              <TertiaryDivider />
              <Card>
                <BottomHeader>{otpHeaderText}</BottomHeader>
                <StyledButton
                  label={otpButtonLabel}
                  onPress={() => handleNavigation('OtpPreConfirmation')}
                />
              </Card>
            </Fragment>
          )}
          shouldRender={isEligibleForOtp}
        />
        <ConditionalRender
          Component={(
            <Fragment>
              <TertiaryDivider />
              <Card>
                <BottomHeader>{flexDraftHeaderText}</BottomHeader>
                <ListView>
                  {flexDraftListText.map((text) => (
                    <ListItem key={text}>
                      <StyledText>{'\u2022  '}</StyledText>
                      <StyledText>
                        <FormattedMessage id={text} />
                      </StyledText>
                    </ListItem>
                  ))}
                </ListView>
                <StyledButton
                  label={flexDraftButtonLabel}
                  onPress={() => handleNavigation('FlexDraftPreConfirmation')}
                />
              </Card>
            </Fragment>
          )}
          shouldRender={isEligibleForFlexDraft}
        />
      </Container>
    </StyledScrollView>
  );
};

MakePaymentSplash.propTypes = {
  isEligibleForAutopay: T.bool.isRequired,
  isEligibleForFlexDraft: T.bool.isRequired,
  isEligibleForOtp: T.bool.isRequired,
  navigation: T.object.isRequired,
};

export default MakePaymentSplash;
